document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-powermail-form-scroll]').forEach((element) => {
        let uid = element.dataset.powermailFormScroll,
            contentElement = document.querySelector('#c' + uid);
        if (uid && contentElement) {
            let submitButton = contentElement.querySelector('button.o-button.powermail_submit, .powermail_fieldwrap_type_submit input[type="submit"]');
            if (submitButton) {
                let header = document.querySelector('.o-header').getBoundingClientRect();
                if (header) {
                    submitButton.addEventListener('click', () => {
                        window.scrollTo({
                            top: contentElement.offsetTop - header.height - 60,
                            behavior: "smooth"
                        });
                    });
                }
            }
        }
    });

    // Show success message after optin for forms which are hidden in closed tabs (e.g. forms on the bottom of product pages)
    document.querySelectorAll('.o-tabs__item-content .optin-mail-success').forEach((element) => {
        const originalParent = element.parentNode;
        const nextSibling = element.nextSibling;

        element.classList.add('optin-fade');
        element.style.position = 'absolute';
        element.style.top = '50%';
        element.style.left = '50%';
        element.style.transform = 'translate(-50%, -50%)';
        element.style.zIndex = '9999';

        document.body.appendChild(element);
        requestAnimationFrame(() => {
            element.classList.add('visible');
        });

        setTimeout(() => {
            element.classList.remove('visible');
            element.classList.add('hidden');

            setTimeout(() => {
                element.classList.remove('optin-fade', 'hidden', 'visible');
                element.style.position = '';
                element.style.top = '';
                element.style.left = '';
                element.style.transform = '';
                element.style.zIndex = '';

                if (nextSibling) {
                    originalParent.insertBefore(element, nextSibling);
                } else {
                    originalParent.appendChild(element);
                }
            }, 500);
        }, 7000);
    });
});